export default function reportPackageUniqueNameDirective(
  $q,
  reportsDataService
) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link,
  };

  function link(scope, element, attributes, ngModel) {
    const reportPackageId = attributes.reportPackageId || -1;
    ngModel.$asyncValidators.prReportPackageUniqueName = (modelValue) => {
      const defer = $q.defer();
      reportsDataService.checkReportPackageExists(modelValue, reportPackageId).then((data) => {
        if (data && !data.data.result) {
          defer.resolve();
        } else {
          defer.reject();
        }
      }).catch(defer.reject);
      return defer.promise;
    };
  }
}

export const name = 'prReportPackageUniqueName';

reportPackageUniqueNameDirective.$inject = [
  '$q',
  'reportsDataService'
];
